module.exports = "<p>\n  account works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/account/account.component.html
// module id = ./src/app/components/account/account.component.html
// module chunks = main